if (!customElements.get('collection-description')) {
  class CollectionDescription extends HTMLElement {
    constructor() {
      super();
      this.toggleBtn = this.querySelector('.collection-description__toggle');

      if (this.toggleBtn) {
        if (this.toggleBtn.dataset.expanded === 'true') {
          this.classList.add('is-expanded');
        }
        this.toggleBtn.addEventListener('click', this.handleToggle.bind(this));
      }
    }

    handleToggle() {
      const isExpanded = this.toggleBtn.dataset.expanded === 'true';
      this.toggleBtn.dataset.expanded = String(!isExpanded);
      this.classList.toggle('is-expanded', !isExpanded);
    }
  }

  customElements.define('collection-description', CollectionDescription);
}
